import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, map, of, switchMap } from 'rxjs'

export const GetOrderNoticesEpic: Epic = (action$, _, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.fetchOrderNotices.match),
    switchMap(({ payload: { orderId } }) =>
      OrderRepository.getOrderNotices(orderId).pipe(
        map((items) => order.fetchOrderNoticesResult({ orderId, items })),
        catchError((error: Error) => {
          console.warn('could not load the order notices', error)
          return of(order.fetchOrderNoticesResult({ orderId, items: [] }))
        })
      )
    )
  )
